document.querySelectorAll('.FormNearMetro__toggle').forEach((el) => {
    const className = el.className;
    el.addEventListener('click', () => {
        el.classList.toggle(`${className}--active`)
    })
})
